<div class="spinner-header">
    <div>{{this.utils.traslatei18n('download-async-report-module.message-snack-title')}}</div>
    <div >
        <button mat-button  (click)="snackBarRef.dismiss()" class="close-button" >X</button>
    </div>
</div>
{{this.utils.traslatei18n('download-async-report-module.message-snack-text')}}
<a  mat-raised-button (click)="doDownload()"  ariaCurrentWhenActive="page" style="text-decoration: underline; font-weight: bold;" > 
    {{this.utils.traslatei18n('download-async-report-module.linkDownload')}}
</a>
